module.exports = __webpack_public_path__ + "img/tips-img-sm.cce01794.png";